"use client"

import { lazy, Suspense } from "react"

// Lazy load the notification component - only loads AFTER hydration
// This ensures zero impact on initial page load (LCP, FCP, TTI)
const SocialProofNotification = lazy(() =>
    import("./SocialProofNotification").then((m) => ({ default: m.SocialProofNotification }))
)

/**
 * Client-side wrapper for SocialProofNotification
 *
 * Performance optimizations:
 * 1. React.lazy() - Component JS not included in initial bundle
 * 2. Suspense with null fallback - No layout shift, silent loading
 * 3. Only loads after hydration - Zero impact on server render
 * 4. Geo data fetched client-side - Landing pages stay fully static
 *
 * This pattern is the recommended way to lazy load client-only
 * components in Next.js 16 App Router (since ssr:false is not
 * allowed in Server Components).
 */
export function SocialProofNotificationWrapper() {
    return (
        <Suspense fallback={null}>
            <SocialProofNotification />
        </Suspense>
    )
}
